import { Routes } from '@angular/router';

export const memoriesRoutes: Routes = [
  {
    path: '',
    redirectTo: '/tabs/memories',
    pathMatch: 'full',
  },
  {
    path: 'memory/:id',
    loadComponent: () => import('#pages/memory/memory.page').then((m) => m.MemoryPage),
  },
  {
    path: 'memory',
    loadComponent: () => import('#pages/memory/memory.page').then((m) => m.MemoryPage),
  },
  {
    path: 'memory/:id/assets',
    loadComponent: () =>
      import('#pages/memory-assets/memory-assets.page').then((m) => m.MemoryAssetsPage),
  },
  {
    path: 'memory/:id/assets/video/:assetId',
    loadComponent: () =>
      import('#pages/memory-video-player/memory-video-player.page').then(
        (m) => m.MemoryVideoPlayerPage
      ),
  },
];
